module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kpc_m.ff177cab11a62dc2f41a7892f8696718.png";